<template>
  <div>
<!--    {{formData}}-->
    <div class="col-md-12 header">
      <h5 class="mt-3 text-dark" style="color:#48a6a6 !important">{{ formData.task.title }}</h5>
    </div>

    <hr class="mb-2">

    <div class="row mt-4">
      <div class="col-12">
        <span class="color-default font-weight-bold">Description</span><br>
        <span style="color:black" v-if="formData.task.assigned_to" v-html="formData.task.description"></span>
        <span v-else>-----</span>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <div>
          <span class="color-default font-weight-bold">Assign To</span><br>
          <span style="color:black" v-if="formData.task.assigned_to">
            {{ formData.task.assigned_to.user_name }}
          </span>
          <span v-else>-----</span>
        </div>
      </div>

      <div class="col-6">
        <div>
          <span class="color-default font-weight-bold">Due Date</span><br>
          <span style="color:black" v-if="formData.task.due_date">
            {{ formData.task.due_date | formatDate }}
          </span>
          <span v-else>-----</span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <div>
          <span class="color-default font-weight-bold">Time</span><br>
          <span style="color:black">{{ formData.task.time }}</span>
        </div>
      </div>

      <div class="col-6">
        <div>
          <span class="color-default font-weight-bold">Created By</span><br>
           <span style="color:black" v-if="formData.task.created_by.last_name">
            {{ formData.task.created_by.last_name }}
          </span>
          <span v-else>-----</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {

  props: [ 'formData'],
  data() {
    return {
      taskDetail: this.formData || {}, // Initialize with prop data
    };
  },
  mounted() {
    // console.log("mounted data =>", this.formData)
    // this.taskDetail = this.formData;
  },
  methods: {},
  filters: {
    formatDate(value) {
      if (value && value !== '0000-00-00 00:00:00') {
        return moment(value).format('MMM DD, YYYY');
      }
      return 'N/A';
    },
    formatDateTime(value) {
      if (value) {
        return moment(value).format('DD MMMM, YYYY [at] hh:mm:ss A');
      }
      return 'N/A';
    },
  },
};
</script>

<style scoped>
.header {
  padding: 0 !important;
}

#tabs .nav-link {
  background: transparent;
  color: rgb(66, 64, 64);
}

#tabs .active {
  background-color: #48a6a6 !important;
  color: white;
}

.vtl {
  position: relative;
  padding: 10px 0px 10px 50px;
  max-width: 1000px;
}

.vtl::before {
  content: '';
  width: 3px;
  background-color: #f4f8fa;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 15px;
}

.event {
  padding: 20px 30px;
  background-color: #f2f5f7;
  position: relative;
  border-radius: 6px;
  margin-bottom: 10px;
}

.event::before {
  content: '';
  border: 10px solid transparent;
  border-right-color: #f2f5f7;
  border-left: 0;
  position: absolute;
  top: 20%;
  left: -10px;
}

.event::after {
  content: '';
  background: #f4f8fa;
  border: 4px solid #48a6a6;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  position: absolute;
  top: 25%;
  left: -40px;
}
</style>
